/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Freeze_Error_Start_DateInputs */

const fr_membership_freeze_error_start_date = /** @type {(inputs: Membership_Freeze_Error_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette date de début n'est pas possible.`)
};

/**

* @param {Membership_Freeze_Error_Start_DateInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_error_start_date = /** @type {((inputs?: Membership_Freeze_Error_Start_DateInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_Error_Start_DateInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_error_start_date(inputs)
});